import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate, useParams } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs';
import Header_3 from '../headers/Header_3';
import Header_2 from '../headers/Header_2';
import { Turnstile } from "@marsidev/react-turnstile";


import DatePicker, { registerLocale } from "react-datepicker";
import { de } from "date-fns/locale";
import { format, parse } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("de", de);

export const AnmeldungWohnen = () => {

    useEffect(() => {
        $(".select2").select2();
    }, []);

    let { title } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [formulare, setFormulare] = useState(null);




    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/formulares?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true");

            const data = await response.json();
            console.log(data);

            if (data.data) {
                setFormulare(data.data);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    useEffect(() => {

        if (formulare?.length > 0 && title) {
            const matchedCategory = formulare?.find((category) => category.slug === title);
            // console.log(category);
            if (matchedCategory) {
                // setCategory(matchedCategory);
                setHeaderModules(matchedCategory?.Bannerbereich);

            } else {
                navigate("/error"); // Redirect to trigger the catch-all error route
            }
        }


    }, [formulare, title]);


    const [formData, setFormData] = useState({
        firstChoice: "",
        secondChoice: "",
        thirdChoice: "",
        rooms: "",
        stockwerk: "",
        rent: "",
        moveIn: "",
        tenants: "",
        adults: "",
        children: "",
        parking: "",
        pets: "",
        message: "",
    });

    const initialTenant = {
        anrede: "",
        einzug: "",
        nachname: "",
        geburtsdatum: "",
        adresse: "",
        plz: "",
        ort: "",
        telefonPrivat: "",
        telefonGeschaft: "",
        email: "",
        income: "",
    };

    const [mieters, setMieters] = useState([initialTenant]);


    // ================= HANDLE FORM =================

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };


    // ================= HANDLE MIETER =================

    const handleMieterChange = (index, e) => {
        const { name, value } = e.target;

        const updated = [...mieters];

        updated[index][name] = value;

        setMieters(updated);

        // REMOVE ERROR ON CHANGE
        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`mieter-${index}-${name}`];
            return newErrors;
        });
    };


    // ================= ADD MIETER =================

    const handleAddMieter = () => {
        if (mieters.length >= 2) return;

        setMieters((prev) => [...prev, initialTenant]);
    };


    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");

                // FOR MAIN FORM
                if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }

                // FOR MIETERS
                if (name === "anrede") {
                    const index = $(".select2[name='anrede']").index(this);

                    console.log("Mieter index:", index, name, value);

                    setMieters((prev) => {
                        const updated = [...prev];
                        updated[index].anrede = value;
                        return updated;
                    });
                }
            });
        });

        // return () => {
        //     // $(".select2").off("change")?.select2("destroy");
        // };

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, [mieters]);


    const [errors, setErrors] = useState({});

    const validateForm = () => {
        let newErrors = {};

        // MAIN FORM REQUIRED FIELDS
        const requiredFields = [
            "firstChoice",
            "rooms",
            "rent",
            "moveIn",
            "adults",
            "children",
            "parking",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        // MIETERS REQUIRED FIELDS
        mieters.forEach((mieter, index) => {
            const requiredMieterFields = [
                "anrede",
                "einzug",
                "nachname",
                "geburtsdatum",
                "adresse",
                "plz",
                "ort",
                "telefonPrivat",
                "email",
            ];

            requiredMieterFields.forEach((field) => {
                if (!mieter[field] || mieter[field].trim() === "") {
                    newErrors[`mieter-${index}-${field}`] = true;
                }
            });
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ================= SUBMIT =================
    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);


    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateForm();

        if (!isValid) {
            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        const payload = {
            ...formData,
            mieters,
        };

        console.log(payload);

        try {
            // API CALL HERE
            setIsSubmitting(true);

            const response = await fetch(`${process.env.REACT_APP_FRONTEND_URL}api/submit-form?pageTitle=${headerModules[0]?.Titel}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            console.log("Form submission response:", data);

            if (data?.success) {
                navigate("/vielen-dank");
            }

            // alert("Form submitted successfully!");
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            let hasError = false;

            if (name === "anrede") {
                const index = $(".select2[name='anrede']").index(this);

                hasError = !!errors[`mieter-${index}-anrede`] && mieters[index].anrede?.trim() === "";
            } else {
                hasError = !!errors[name] && formData[name]?.trim() === "";
            }

            if (hasError) {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border shake");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");
            }
        });
    }, [errors]);

    return (
        <div className='page-content'>
            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" activeInnerPage="Wohnen in der BGZ" />
                        )}
                    </React.Fragment>
                ))
            )}

            <section className='pt-pb-10 anmeldung_wohnen_form sec-orange-color'>
                <form className="form-container" onSubmit={handleSubmit}>
                    <div className='container'>
                        <div className='sec-title'>
                            <h2 className='fs_40 fw-550 title-line-before text-darkgrey mb-4'>Ihre gewünschte Wohnung</h2>
                        </div>
                        <div className='row'>
                            <div className={`col-sm-6 form-group`}>
                                <select
                                    className={`form-control select2`}
                                    name="firstChoice"
                                    value={formData.firstChoice}
                                >
                                    <option value="" className="placeholder" disabled>
                                        1. Wahl Quartier / Ort
                                    </option>

                                    <option value="Albisrieden (Kreis 9)">
                                        Albisrieden (Kreis 9)
                                    </option>

                                    <option value="Altstetten (Kreis 9)">
                                        Altstetten (Kreis 9)
                                    </option>

                                    <option value="Aussersihl (Kreis 4)">
                                        Aussersihl (Kreis 4)
                                    </option>

                                    <option value="Höngg (Kreis 10)">
                                        Höngg (Kreis 10)
                                    </option>

                                    <option value="Leimbach (Kreis 2)">
                                        Leimbach (Kreis 2)
                                    </option>

                                    <option value="Wiedikon (Kreis 3)">
                                        Wiedikon (Kreis 3)
                                    </option>

                                    <option value="Wipkingen (Kreis 10)">
                                        Wipkingen (Kreis 10)
                                    </option>

                                    <option value="Wollishofen">
                                        Wollishofen
                                    </option>

                                    <option value="Adliswil">
                                        Adliswil
                                    </option>

                                    <option value="Feldmeilen">
                                        Feldmeilen
                                    </option>

                                    <option value="Gattikon">
                                        Gattikon
                                    </option>

                                    <option value="Horgen">
                                        Horgen
                                    </option>

                                    <option value="Küsnacht">
                                        Küsnacht
                                    </option>

                                    <option value="Langnau am Albis">
                                        Langnau am Albis
                                    </option>

                                    <option value="Meilen">
                                        Meilen
                                    </option>

                                    <option value="Oberrieden">
                                        Oberrieden
                                    </option>

                                    <option value="Thalwil">
                                        Thalwil
                                    </option>

                                    <option value="Ganze Stadt Zürich">
                                        Ganze Stadt Zürich
                                    </option>

                                    <option value="Ganzer Kanton Zürich">
                                        Ganzer Kanton Zürich
                                    </option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="secondChoice"
                                    value={formData.secondChoice}
                                >
                                    <option value="" className="placeholder" disabled>
                                        2. Wahl Quartier / Ort
                                    </option>

                                    <option value="Albisrieden (Kreis 9)">
                                        Albisrieden (Kreis 9)
                                    </option>

                                    <option value="Altstetten (Kreis 9)">
                                        Altstetten (Kreis 9)
                                    </option>

                                    <option value="Aussersihl (Kreis 4)">
                                        Aussersihl (Kreis 4)
                                    </option>

                                    <option value="Höngg (Kreis 10)">
                                        Höngg (Kreis 10)
                                    </option>

                                    <option value="Leimbach (Kreis 2)">
                                        Leimbach (Kreis 2)
                                    </option>

                                    <option value="Wiedikon (Kreis 3)">
                                        Wiedikon (Kreis 3)
                                    </option>

                                    <option value="Wipkingen (Kreis 10)">
                                        Wipkingen (Kreis 10)
                                    </option>

                                    <option value="Wollishofen">
                                        Wollishofen
                                    </option>

                                    <option value="Adliswil">
                                        Adliswil
                                    </option>

                                    <option value="Feldmeilen">
                                        Feldmeilen
                                    </option>

                                    <option value="Gattikon">
                                        Gattikon
                                    </option>

                                    <option value="Horgen">
                                        Horgen
                                    </option>

                                    <option value="Küsnacht">
                                        Küsnacht
                                    </option>

                                    <option value="Langnau am Albis">
                                        Langnau am Albis
                                    </option>

                                    <option value="Meilen">
                                        Meilen
                                    </option>

                                    <option value="Oberrieden">
                                        Oberrieden
                                    </option>

                                    <option value="Thalwil">
                                        Thalwil
                                    </option>

                                    <option value="Ganze Stadt Zürich">
                                        Ganze Stadt Zürich
                                    </option>

                                    <option value="Ganzer Kanton Zürich">
                                        Ganzer Kanton Zürich
                                    </option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="thirdChoice"
                                    value={formData.thirdChoice}
                                >
                                    <option value="" className="placeholder" disabled>
                                        3. Wahl Quartier / Ort
                                    </option>

                                    <option value="Albisrieden (Kreis 9)">
                                        Albisrieden (Kreis 9)
                                    </option>

                                    <option value="Altstetten (Kreis 9)">
                                        Altstetten (Kreis 9)
                                    </option>

                                    <option value="Aussersihl (Kreis 4)">
                                        Aussersihl (Kreis 4)
                                    </option>

                                    <option value="Höngg (Kreis 10)">
                                        Höngg (Kreis 10)
                                    </option>

                                    <option value="Leimbach (Kreis 2)">
                                        Leimbach (Kreis 2)
                                    </option>

                                    <option value="Wiedikon (Kreis 3)">
                                        Wiedikon (Kreis 3)
                                    </option>

                                    <option value="Wipkingen (Kreis 10)">
                                        Wipkingen (Kreis 10)
                                    </option>

                                    <option value="Wollishofen">
                                        Wollishofen
                                    </option>

                                    <option value="Adliswil">
                                        Adliswil
                                    </option>

                                    <option value="Feldmeilen">
                                        Feldmeilen
                                    </option>

                                    <option value="Gattikon">
                                        Gattikon
                                    </option>

                                    <option value="Horgen">
                                        Horgen
                                    </option>

                                    <option value="Küsnacht">
                                        Küsnacht
                                    </option>

                                    <option value="Langnau am Albis">
                                        Langnau am Albis
                                    </option>

                                    <option value="Meilen">
                                        Meilen
                                    </option>

                                    <option value="Oberrieden">
                                        Oberrieden
                                    </option>

                                    <option value="Thalwil">
                                        Thalwil
                                    </option>

                                    <option value="Ganze Stadt Zürich">
                                        Ganze Stadt Zürich
                                    </option>

                                    <option value="Ganzer Kanton Zürich">
                                        Ganzer Kanton Zürich
                                    </option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="rooms"
                                    value={formData.rooms}
                                >
                                    <option value="" className="placeholder" disabled>
                                        Anzahl Zimmer *
                                    </option>

                                    <option value="1-2 Zimmer">
                                        1-2 Zimmer
                                    </option>

                                    <option value="3 Zimmer">
                                        3 Zimmer
                                    </option>

                                    <option value="4 Zimmer">
                                        4 Zimmer
                                    </option>

                                    <option value="5 Zimmer">
                                        5 Zimmer
                                    </option>

                                    <option value="mehr als 5 Zimmer">
                                        mehr als 5 Zimmer
                                    </option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Stockwerk"
                                    name="stockwerk"
                                    value={formData.stockwerk}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="rent"
                                    value={formData.rent}
                                >
                                    <option value="" className='placeholder' disabled>
                                        Höchstmiete *
                                    </option>

                                    <option value="bis CHF 1'000">bis CHF 1'000</option>
                                    <option value="bis CHF 1'500">bis CHF 1'500</option>
                                    <option value="bis CHF 2'000">bis CHF 2'000</option>
                                    <option value="bis CHF 2'500">bis CHF 2'500</option>
                                    <option value="bis CHF 3'000">bis CHF 3'000</option>
                                    <option value="bis CHF 3'500">bis CHF 3'500</option>
                                    <option value="über CHF 3'500">über CHF 3'500</option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.moveIn ? "warning-border shake" : ""}`}
                                    placeholder="Einzug per *"
                                    name="moveIn"
                                    value={formData.moveIn}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="tenants"
                                    value={formData.tenants}
                                >
                                    <option value="" className="placeholder" disabled>
                                        Anzahl Mieter
                                    </option>

                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="adults"
                                    value={formData.adults}
                                >
                                    <option value="" className="placeholder" disabled>
                                        Anzahl erwachsene Personen *
                                    </option>

                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="children"
                                    value={formData.children}
                                >
                                    <option value="" className="placeholder" disabled>
                                        Anzahl Kinder *
                                    </option>

                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='sec-bg-grey pt-pb-10 mt-10'>
                        <div className='container'>
                            <div className='sec-title'>
                                <h2 className='fs_40 fw-550 title-line-before text-darkgrey mb-4'>Ihre persönlichen Angaben</h2>
                            </div>
                            {mieters.map((mieter, index) => (
                                <div className={`meiter_wrapper ${mieters?.length > 1 && index === 0 ? "mb-4" : ""}`} key={index}>
                                    <h4 className="fw-450 text-darkgrey mb-4">
                                        Mieter {index + 1}
                                    </h4>

                                    <div className="row">
                                        <div className="col-sm-12 form-group">
                                            <select
                                                className="form-control select2"
                                                name="anrede"
                                                value={mieter.anrede}
                                            >
                                                <option value="" disabled>
                                                    Anrede *
                                                </option>

                                                <option value="Frau">Frau</option>
                                                <option value="Herr">Herr</option>
                                            </select>
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-einzug`] ? "warning-border shake" : ""}`}
                                                placeholder="Einzug per *"
                                                name="einzug"
                                                value={mieter.einzug}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-nachname`] ? "warning-border shake" : ""}`}
                                                placeholder="Nachname *"
                                                name="nachname"
                                                value={mieter.nachname}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group position-relative">
                                            <DatePicker
                                                selected={
                                                    mieter.geburtsdatum
                                                        ? parse(mieter.geburtsdatum, "dd.MM.yyyy", new Date())
                                                        : null
                                                }
                                                onChange={(date) => {
                                                    const updated = [...mieters];

                                                    updated[index].geburtsdatum = date
                                                        ? format(date, "dd.MM.yyyy")
                                                        : "";

                                                    setMieters(updated);

                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        [`mieter-${index}-geburtsdatum`]: false,
                                                    }));
                                                }}
                                                locale="de"
                                                dateFormat="dd.MM.yyyy"
                                                placeholderText="Geburtsdatum *"
                                                className={`form-control ${errors[`mieter-${index}-geburtsdatum`] ? "warning-border shake" : ""}`}
                                                isClearable
                                            />
                                            {!mieter.geburtsdatum && <img className='calender-icon' src="images/calender-icon-bgz2.svg" alt="" />}
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-adresse`] ? "warning-border shake" : ""}`}
                                                placeholder="Aktuelle Adresse *"
                                                name="adresse"
                                                value={mieter.adresse}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-plz`] ? "warning-border shake" : ""}`}
                                                placeholder="PLZ *"
                                                name="plz"
                                                value={mieter.plz}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-ort`] ? "warning-border shake" : ""}`}
                                                placeholder="Ort *"
                                                name="ort"
                                                value={mieter.ort}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-telefonPrivat`] ? "warning-border shake" : ""}`}
                                                placeholder="Telefon Privat *"
                                                name="telefonPrivat"
                                                value={mieter.telefonPrivat}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`mieter-${index}-nachname`] ? "warning-border shake" : ""}`}
                                                placeholder="Telefon Geschäft"
                                                name="telefonGeschaft"
                                                value={mieter.telefonGeschaft}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="email"
                                                className={`form-control ${errors[`mieter-${index}-email`] ? "warning-border shake" : ""}`}
                                                placeholder="E-Mail *"
                                                name="email"
                                                value={mieter.email}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>

                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Bruttojahreseinkommen (CHF)"
                                                name="income"
                                                value={mieter.income}
                                                onChange={(e) =>
                                                    handleMieterChange(index, e)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {mieters.length < 2 && <button
                                type="button"
                                className="simple-add-btn"
                                onClick={handleAddMieter}
                                disabled={mieters.length >= 2}
                            >
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="7.19922" width="1.2" height="15.6" rx="0.6" fill="white" />
                                        <rect x="15.5996" y="7.19922" width="1.2" height="15.6" rx="0.6" transform="rotate(90 15.5996 7.19922)" fill="white" />
                                    </svg>
                                </span>Mieter hinzufügen
                            </button>}
                        </div>
                    </div>
                    <div className='container mt-10'>
                        <div className='sec-title'>
                            <h2 className='fs_40 fw-550 title-line-before text-darkgrey mb-4'>Allgemeine Informationen</h2>
                        </div>
                        <div className='row'>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className="form-control select2"
                                    name="parking"
                                    value={formData.parking}
                                >
                                    <option value="" disabled>
                                        Wie viele Parkplätze benötigen Sie? Anzahl Fahrzeuge*
                                    </option>

                                    <option value="1 Fahrzeug">
                                        1 Fahrzeug
                                    </option>

                                    <option value="2 Fahrzeuge">
                                        2 Fahrzeuge
                                    </option>

                                    <option value="3 Fahrzeuge oder mehr">
                                        3 Fahrzeuge oder mehr
                                    </option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Besitzen Sie Haustiere? Wenn ja, welche/s?"
                                    name="pets"
                                    value={formData.pets}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 form-group'>
                                <textarea
                                    rows={5}
                                    className="form-control"
                                    placeholder="Ihre Mitteilung"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-6 form-captcha'>
                                <div className='google_recaptcha'>
                                    <Turnstile
                                        siteKey="0x4AAAAAADt5N15MzxPtrdSe"
                                        onSuccess={(token) => {
                                            setCaptchaToken(token);
                                            setCaptchaError(false);
                                        }}
                                        onExpire={() => {
                                            setCaptchaToken("");
                                        }}
                                    />

                                    {captchaError && (
                                        <p
                                            style={{
                                                color: "red",
                                                marginTop: "10px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Bitte bestätigen Sie das Captcha.
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className='col-sm-6 form-btn'>
                                <button type='submit' className="button round_btn btn-theme-color" disabled={isSubmitting}>Absenden
                                    <span>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    )
}